module.exports = __webpack_public_path__ + "img/symbol-4.1a78a375.svg";